import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Page from '../../page';
import BackButton from '../BackButton';
import MyCart from '../MyCart/MyCart';
import APIDirectoryHomeContainer from './APIDirectoryHomeContainer';
import APIDetailsContainer from './APIDetailsContainer';
import { setAPIDirectoryPage } from '../../../redux/connectedComponent/apiDirectory/apiDirectory.slice';
import {
  getCartDetails,
  getOrders,
} from '../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { API_DIRECTORY_PAGE } from '../../../constants/APIDirectoryConstants';
import { setScreen } from '../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../config/uiFactory.config';
import {
  sendAmplitudeData,
  getOrgAmplitudeProperties,
} from '../../../utils/amplitude';
import { AMPLITUDE_EVENTS } from '../../../constants/amplitudeConstants';
import { PAGE_TITLE } from '../../../constants/constants';
import { trackPageView, PAGE_SECTIONS, PAGE_SUBSECTIONS } from '../../../utils/gtm';

const DealerAPIDirectory = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { fortellisEnterpriseEntityId, authenticationToken: token } =
    state?.loginDetailsSlice;
  const currentComponent = state?.apiDirectorySlice?.componentToRender || {
    page: API_DIRECTORY_PAGE.HOME,
    props: {},
  };
  const { cart } = state?.orderAPISlice;
  const [showCart, setShowCart] = useState(false);
  const [filters, setFilters] = useState({
    selectedAPIType: [],
    selectedDomainIds: [],
    selectedFilterType: [],
    newUrl: '',
  });

  const orgAmplitudeProperties = getOrgAmplitudeProperties(
    state?.loginDetailsSlice
  );

  const navigateTo = (page, props) => {
    dispatch(
      setAPIDirectoryPage({ page: page, props: { ...props, ...filters } })
    );
  };

  const handleMyCart = () => {
    setShowCart(true);
    sendAmplitudeData(AMPLITUDE_EVENTS.DEALER_MY_CART, orgAmplitudeProperties);
  };

  useEffect(() => {
    if (fortellisEnterpriseEntityId) {
      dispatch(getOrders({ token }));
      dispatch(
        getCartDetails({ entityId: fortellisEnterpriseEntityId, token })
      );
    }
  }, [fortellisEnterpriseEntityId]);

  useEffect(() => {
    if (currentComponent?.page === API_DIRECTORY_PAGE.HOME) {
      trackPageView({ page_section: PAGE_SECTIONS.API_DIRECTORY, page_subsection: PAGE_SUBSECTIONS.OVERVIEW });
    }
  }, [currentComponent?.page]);

  const onBack = () => {
    if (currentComponent.page === API_DIRECTORY_PAGE.HOME) {
      history.push('/dp/home');
      dispatch(setScreen({ screen: screens.DASHBOARD }));
    } else if (currentComponent.props?.prevScreen === 'myApis') {
      history.goBack();
    } else {
      navigateTo(API_DIRECTORY_PAGE.HOME, filters);
    }
  };

  const renderAPIDirPage = () => {
    switch (currentComponent.page) {
      case API_DIRECTORY_PAGE.HOME:
        return (
          <APIDirectoryHomeContainer
            handleMyCart={handleMyCart}
            filters={filters}
            setFilters={setFilters}
            {...currentComponent.props}
          />
        );
      case API_DIRECTORY_PAGE.DETAILS:
        return (
          <>
            <BackButton onBack={onBack} />
            <APIDetailsContainer
              handleMyCart={handleMyCart}
              {...currentComponent.props}
            />
          </>
        );
      default:
        return null;
    }
  };

  const pageHeader =
    currentComponent.page === API_DIRECTORY_PAGE.HOME
      ? PAGE_TITLE.DIRECTORY
      : PAGE_TITLE.DEALER_PORTAL;

  return (
    <Page pageHeader={pageHeader}>
      {renderAPIDirPage()}
      {showCart && <MyCart setShowCart={setShowCart} />}
    </Page>
  );
};

export default DealerAPIDirectory;
